import {React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import MuiTable from "../common/MuiTable";
import { energyOptions, intervalOptions, methodOptions, predictorVariable } from "../common/commonVal";
import { UI_1_2_tableRow1, UI_1_2_tableRow2 } from "./UI_1_2.hepler";
import { formatDateFromBigInt, formatTimeRange1, getMonthBetween, getDay, getInloInfo} from "../common/commonMethod";
import UI_1_2_Chart from "./UI_1_2_Chart";

/**
 * @description 수요공급예측 > 예측정확도
 * @author CHOISEONHA
 * @date 04/12/2024
 * @param {*}
 * @return  수요공급예측 > 예측정확도
 */

export const UI_1_2 = () => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [onePlant, setOnePlant] = useState(null);
  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    method: "prod",
    energy: "AIR",
    interval: "realtime",
    startDate: getDay(-1),
    endDate:  getDay(-1)
  });
  const [fetchData, setFetchData] = useState([]);
  const [params, setParams] = useState({});
  const [accuracy, setAccuracy] = useState();
  const [errorRate, setErrorRate] = useState();
  const [rsquare, setRsquare] = useState();
  const [cvrmse, setCvrmse] = useState();


  const dataGrid1 = (
    year,             // 날짜
    time,             // 시간
    energy,           // 에너지종류
    method,           // 사용/공급
    unit,             // 단위
    complexName,      // 산업단지명
    companyName,      // 회사명
    plantName,        // 사업장명
    actualSupply,     // 실제공급량
    predictedSupply,  // 예측공급량
    errorRate         // 오차율
  ) => {
    return {
      year,
      time,
      energy,
      method,
      unit,
      complexName,
      companyName,
      plantName,
      actualSupply,
      predictedSupply,
      errorRate
    };
  };

  const dataGrid2 = (
    year,               // 날짜
    energy,             // 에너지종류
    method,             // 사용/공급
    unit,               // 단위
    complexName,        // 산업단지명
    companyName,        // 회사명
    plantName,          // 사업장명
    actualSupply,       // 실제공급량
    predictedSupply,    // 예측공급량
    predictionAccuracy, // 에측정확도
    errorRate,          // 오차율
    accuracy            // 정확도
  ) => {
    return {
      year,
      energy,
      method,
      unit,
      complexName,
      companyName,
      plantName,
      actualSupply,
      predictedSupply,
      predictionAccuracy,
      errorRate,
      accuracy
    };
  };


  // 실시간 조회 선택 시
  const resultRow1 = fetchData.map(item => {
    // 기본적으로 사용할 날짜와 관련 데이터 설정
    const date = params.method === "prod" ? formatDateFromBigInt(item.prodDtm) : formatDateFromBigInt(item.consDtm);
    const time = params.method === "prod" ? formatTimeRange1(item.prodDtm) : formatTimeRange1(item.consDtm);
    const amount = params.method === "prod" ? item.prodAmt : item.consAmt;
    const expectedAmount = params.method === "prod" ? item.expProdAmt : item.expConsAmt;

    return dataGrid1(
      date,
      time,
      item.engDescr,
      item.method,
      item.engUnit,
      item.complexInloName,      
      amount,
      expectedAmount,
      item.errorRate
    );
  });


  // 1일 조회 선택 시
  const resultRow2 = fetchData.map(item => {
    const date = params.method === "prod" ? formatDateFromBigInt(item.prodDate) : formatDateFromBigInt(item.consDate);
    const amount = params.method === "prod" ? item.prodAmt : item.consAmt;
    const expectedAmount = params.method === "prod" ? item.expProdAmt : item.expConsAmt;

    return dataGrid2(
      date,
      item.engDescr,
      item.method,
      item.engUnit,
      item.complexInloName,      
      amount,
      expectedAmount,
      item.errorRate,
      item.accuracy
    )
  })




  useEffect(()=> {
    if (user.inloClCd === "PROJECT" || user.inloClCd === "COMPLEX") {
      getComplexInloData();
    } else {
      getPlantInloData(user.inloNo);
    }
  }, []);

  // complexInloNo가 설정되면 회사 목록을 가져오도록 useEffect 추가
  useEffect(() => {
    if (selected.complexInloNo) {
      selectedComplex(selected.complexInloNo);
    }
  }, [selected.complexInloNo]);

  useEffect(()=>{
    console.log("selected :::: >>>" , selected);
  }, [selected])

  useEffect(()=>{
    selectedComplex(selected.complexInloNo);
  },[selected.method, selected.energy])

  useEffect (() => {
    if (onePlant) {
      setSelected((prev) => ({ ...prev, plantInloNo: onePlant.inloNo }));
    }
  },[onePlant]);

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if(user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } 
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  // 공장로그인 일 경우, 해당 공장만 조회
  const getPlantInloData = async (value) => {
    const uri = "vup/getPlant/" + value;
    try {
      const res = await FxmsData.GET(uri);
      setOnePlant(res.data);
      console.log("getPlant .. >", res.data[0]);
    } catch (e) {
      console.log("getPlant error..", e);
    }
  }

    const selectedComplex = async (value) => {
      console.log("선택된 산단번호 ::", value);
      setSelected((prev) => ({ ...prev, complexInloNo: value }));
      const uri = "vup/getCompanyInloListNew";
  
      const param = {
        energy: selected.energy,
        sourceSink: selected.method ==='cons'? 'SINK':'SOURCE',
        complexInloNo: value,
      }
  
      try {
        const res = await FxmsData.GET(uri, param)
        setFetchCompanyInlo(res.data);
        setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
        console.log("company List >>", res.data);
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }

  const selectedCompany = async (value) => {
    console.log("선택된 회사번호 :: ", value);
    setSelected((prev) => ({ ...prev, companyInloNo: value }));
    const uri = "vup/getPlantInloList/" + value;
    try {
      const res = await FxmsData.GET(uri);
      setFetchPlantInlo(res.data);
      setSelected((prev) => {
        return { ...prev, plantInloNo: res.data[0].inloNo };
      });
      console.log("plant List >>", res.data);
    } catch (e) {
      console.log("getPlantInloList error.... ", e);
    }
  }

  const selectedPlant = (value) => {
    setSelected((prev) => ({ ...prev, plantInloNo: value }));
  }

  const handleSelectData = (event) => {
    const {value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }

  const selectedInterval = (e) => {
    const value = e.target.value;
    setSelected((prev) => ({...prev, interval: value}));
    setFetchData([]);

    if(value ==='day'){
      setSelected((prev) => ({...prev, startDate: getDay(-7)}));
      setSelected((prev) => ({...prev, endDate: getDay(1)}));   
    }else{
      setSelected((prev) => ({...prev, startDate: getDay(-1)}));
    }

  }

  useEffect(() => {
    if (selected.interval && selected.plantInloNo !== "") {
      submitBtnClick();
    }
  }, [selected.interval]);

  useEffect(() => {
    console.log("*** UI_2_1 ***");

  
      getComplexInloData();
  
  }, [inlo,user]);

  // 조회 버튼 클릭 시 데이터 GET 함수
  const submitBtnClick = async () => {
    if (selected.energy === "") {
      alert("에너지 종류를 선택해주세요.");
      return;
    } else if (user.inloClCd === "PROJECT" && (selected.complexInloNo === "" )) {
      alert("산업단지명을 선택해주세요.");
      return;
    }
    
    // 'realtime' 일 경우, endDate에서 3개월 이내인지 확인
    if (selected.interval === "realtime") {

      if (getMonthBetween(selected.startDate.replace(/-/gi, ""), getDay(0).replace(/-/gi, "")) > 3){
        alert("Realtime 간격을 선택하셨을 경우, 최대 3개월까지 조회 가능합니다.");
        return;
      }
    }

    if (selected.interval === "day") {
      if (getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 5*12){
        alert("1일 간격을 선택하셨을 경우, 최대 5년까지 조회 가능합니다.");
        return;
      }
    }

    setFetchData([]);
    const param = {
      startDate: (selected.startDate).replace(/-/gi, ""),
      endDate: (selected.endDate).replace(/-/gi, ""),
      method: selected.method,
      engId: selected.energy,
      interval: selected.interval,
      complexInloNo: selected.complexInloNo,
    
    };

    setParams(param);

    try {
      const res = await FxmsData.GET('vup/select_1_1', param); // select_1_1과 백앤드 로직이 동일하여 재활용
      if (res.data.length > 0 && res.status === 200) { // axios 사용 시 response 상태 검사
        console.log("response.data"); // 서버 응답 출력
        if (res.data[0]) {

           setAccuracy((res.data.reduce((sum, cur) => sum + cur.accuracy, 0) / res.data.length).toFixed(2));
           setErrorRate((res.data.reduce((sum, cur) => sum + cur.errorRate, 0) / res.data.length).toFixed(2));
           setRsquare((res.data.reduce((sum, cur) => sum + cur.rsquare, 0) / res.data.length).toFixed(2));
           setCvrmse((res.data.reduce((sum, cur) => sum + cur.cvrmse, 0) / res.data.length).toFixed(2));
         // 전부평균으로 변경 
         // setAccuracy(res.data[0].accuracy ? res.data[0].accuracy : -1);
         // setErrorRate(res.data[0].errorRate ? res.data[0].errorRate : -1);
         // setRsquare(res.data[0].rsquare ? res.data[0].rsquare : -1);
         // setCvrmse(res.data[0].cvrmse ? res.data[0].cvrmse : -1);


          setFetchData(res.data);
        }
      } 
    } catch (error) {
      setFetchData([]);
      console.error('Network error:', error); // 네트워크 오류 출력
    }
  };


  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="energy" onChange={handleSelectData}>
              {energyOptions.map((item, index) => (
                <option key={index} value={item.value} name="energy">{item.label}</option>
              ))}
            </select>
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="method" onChange={handleSelectData}>
              {methodOptions.map((item, index) => (
                <option key={index} value={item.value} name="method">{item.label}</option>
              ))}
            </select>
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
              {user.inloClCd === "PROJECT" ?
                <>
                  <option value="">산업단지 전체</option>
                  {fetchComplexInlo.map((item) => (
                    <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                      {item.inloName}
                    </option>
                  ))}
                </>
              :
                <option value={fetchComplexInlo.inloNo}> {fetchComplexInlo.inloName} </option>
              }
            </select>
            }
          
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="date" name="startDate" value={selected.startDate}  onChange={handleSelectData} />
          {selected.interval === 'realtime' ? null :
          <><label className="FxLabelSearch">~</label>
          <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={handleSelectData} />
          </>
          }
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick} />
        </div>
      </div>
      <div className="FxCrudDataGrid">
        <div className="FxDataTitle">공급 예측정확도</div>
        <div className="chartOption">
        <div class="charOptionLeft">
              {intervalOptions.map((option, index) => (
                <>
                <input type="radio" id={option.value} name="interval" value={option.value} onChange={(e) => selectedInterval(e)} checked={selected.interval === option.value}/>
                <label>{option.label}</label>
                </>
              ))}
          </div>
          <div className="charOptionPop">
            <b>예측성능</b>
            <ul>
                <li>R2 : {rsquare}</li>
                <li>CvRMSE : {cvrmse}%</li>
            </ul>
          </div>
        </div>
        <UI_1_2_Chart chartData={fetchData} interval={selected.interval} method={selected.method} />
        <div className="chartBottom">
          <p>
              <span>평균오차율 {errorRate}%</span>
              <span>예측정확도 {accuracy}%</span>
          </p>
        </div>
      </div>
      <div class="FxCrudDataGrid">
        <div class="FxMuiTable">
          {/* {fetchData.length > 0 ?
          <MuiTable
            tableRowDataList={
              selected.interval === "realtime" ? UI_1_2_tableRow1 : UI_1_2_tableRow2
            }
            rows={
              selected.interval === "realtime" ? resultRow1 : resultRow2
            }
          />
          :
          <div>
            데이터가 없습니다
          </div>
          } */}
          <MuiTable
            tableRowDataList={
              selected.interval === "realtime" ? UI_1_2_tableRow1 : UI_1_2_tableRow2
            }
            rows={
              selected.interval === "realtime" ? resultRow1 : resultRow2
            }
            excelExport={"true"}
            interval={selected.interval}
            menuFullName='수요예측/예측정확도'
          />
        </div>
      </div>
    </div>
    </>
  )

}
